import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { device } from '../../Styles/mediaQueries'
import Badge from '../../Components/Atoms/Badge'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  border-bottom: 1px solid #e7e8e7;

  @media ${device.mobileL} {
    justify-content: start;
    padding: 0 20px;
  }
`

export const Logo = styled.img`
  height: 34px;
  margin: 10px 0;
  display: block;

  @media ${device.mobileL} {
    height: 40px;
    margin: 4px 0;
  }
`

export const LogoLink = styled(Link)`
  position: relative;
  margin-right: 5px;
`

export const FloatingBadge = styled(Badge)`
  position: absolute;
  background-color: white;
  left: 60%;
  top: 65%;
  border-radius: 4px;
  border: 1px solid grey;
`

export const NavToggle = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 2.8rem;
  color: #3a3a3a;
  position: absolute;
  left: 18px;
  display: inline-flex;
  &:focus {
    background: transparent;
  }
`
